import { ActionHandler } from "../index";
import { prefetchCancellationMedication } from "src/hooks/telehealth/useCancellationMedication";

/**
 * Starts loading the cancellation medication without blocking navigation, so
 * the membership and medication cancellation pages render without a loader.
 */
export const prefetchCancellationMedicationAction: ActionHandler = () => {
  prefetchCancellationMedication();
};
